import { cn } from "@edusogno/lib/utils.js";
import { Trans } from "react-i18next";
import { getMessage } from "@/utils/home";
import { MessageEnum } from "@/types";
import Card from "./Card";
import Dash from "../icons/home/Dash";
import alien from "@/assets/animations/alien.json";
import Lottie from "react-lottie-player";

type Props = {
  message: MessageEnum;
  className?: string;
  lessonsDone?: number;
  kickoffDate?: string;
  exercisesDone?: number;
  recentlyDoneLessons?: number;
  recentlyDoneExercises?: number;
  percentageLessonsDone?: number;
  percentageExecisesDone?: number;
};

const MobileStats: React.FC<Props> = ({
  message,
  className,
  lessonsDone,
  kickoffDate,
  exercisesDone,
  recentlyDoneExercises,
  percentageLessonsDone,
  percentageExecisesDone,
}) => {
  const noPercentageLessonsDone = !(
    typeof percentageLessonsDone === "number" && isFinite(percentageLessonsDone)
  );

  const noPercentageExercisesDone = !(
    typeof percentageExecisesDone === "number" &&
    isFinite(percentageExecisesDone)
  );

  return (
    <div className={cn(className, "flex-col flex h-full gap-4")}>
      <Card key="one" className="flex-[1_1_100%] min-h-0  gap-4 items-center py-4 w-full flex">
        <Lottie
          loop
          play
          style={{
            flex: "1 1 12vh",
            width: "100%",
            height: "12vh",
            marginTop: "auto",
            maxHeight: "300px",
            marginBottom: "auto",
          }}
          animationData={alien}
        />

        <p className="text-secondary text-center text-xs  [&>b]:text-2xl  leading-[120%]">
          {getMessage(message, kickoffDate)}
        </p>
      </Card>

      <div className="flex w-full flex-[1_0_100px] h-full flex-row gap-4">
        <Card key="two" className="w-full grid grid-cols-1 grid-rows-[40px_auto] py-4 px-6">
          {lessonsDone && lessonsDone > 0 ? (
            <div className="text-3xl font-semibold text-secondary">
              {lessonsDone}
            </div>
          ) : (
            <Dash className="my-auto" />
          )}

          <p className="text-xs leading-[150%]">
            <Trans
              values={{
                lessons_done: !noPercentageLessonsDone
                  ? percentageLessonsDone
                  : 0,
              }}
              i18nKey="home.course.lessons_done" // optional -> fallbacks to defaults if not provided
              defaults="Lessons done <br/> <bold>{{lessons_done}}%</bold>" // optional defaultValue
              components={{
                br: <br />,
                bold: <b className="font-semibold capitalize text-primary" />,
              }}
            />
          </p>
        </Card>

        <Card key="three" className="w-full grid grid-cols-1 grid-rows-[40px_auto] py-4 px-6">
          {exercisesDone && exercisesDone > 0 ? (
            <div className="text-3xl font-semibold text-secondary">
              {exercisesDone}

              {Boolean(recentlyDoneExercises && recentlyDoneExercises > 0) && (
                <sup className="text-[#219653] text-[10px] align-super leading-[100%]">
                  +{recentlyDoneExercises}
                </sup>
              )}
            </div>
          ) : (
            <Dash className="my-auto" />
          )}

          <p className="text-xs leading-[150%]">
            <Trans
              i18nKey="home.course.exercises_done" // optional -> fallbacks to defaults if not provided
              defaults="Exercises done <br/> <bold>{{lessons_done}}%</bold>" // optional defaultValue
              values={{
                lessons_done: !noPercentageExercisesDone
                  ? percentageExecisesDone
                  : 0,
              }}
              components={{
                br: <br />,
                bold: <b className="font-semibold capitalize text-primary" />,
              }}
            />
          </p>
        </Card>
      </div>
    </div>
  );
};

export default MobileStats;
